/**
 * FatturazionePagina.jsx — Fatture dello stile dell'utenza (interruttore
 * dello stile, Alex 14/10/2026; fase 5).
 *
 * Con lo stile di prima e' Fatturazione, tale e quale a 638a8209; con lo stile
 * nuovo «Console» e' FatturazioneConsole, che ha i riquadri del periodo, i
 * filtri coi numeri, lo scarto dello SdI aperto nella riga, il trimestre e le
 * bozze. Due componenti, due fogli (Fatturazione.css sotto .stile-classico,
 * FatturazioneConsole.css sotto .stile-console) e non una condizione dentro
 * uno solo: a interruttore spento il disegno e' quello di prima per
 * costruzione, e quando il vecchio stile si toglie si cancellano i file senza
 * ripulire un componente. Le finestre (nuovo documento, bozza, nota di
 * credito) sono le stesse, esportate da Fatturazione.jsx.
 * Lo stile lo decide il server e arriva con l'utente (navigazione/paginaIniziale).
 *
 * @varianti Fatturazione.jsx FatturazioneConsole.jsx
 */
import React from 'react';
import { useAuthStore } from '../store/useStore';
import { stileNuovo } from '../navigazione/paginaIniziale';
import Fatturazione from './Fatturazione';
import FatturazioneConsole from './FatturazioneConsole';

const FatturazionePagina = () => {
    const utente = useAuthStore((st) => st.user);
    return stileNuovo(utente) ? <FatturazioneConsole /> : <Fatturazione />;
};

export default FatturazionePagina;
